import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Button } from 'dibs-elements/exports/Button';

import styles from './HpRespEditorialModuleItem.scss';

function HpRespEditorialModuleItem({ item, onClick }) {
    return (
        <div className={classnames(styles.itemWrapper, 'colXs12 colLg6')}>
            <div className={styles.item}>
                <div className={styles.linkWrapper}>
                    <a className={styles.link} href={item.link} onClick={onClick}>
                        <img className={styles.image} src={item.imageUrl} />
                    </a>
                </div>
                <div className={styles.content}>
                    <div className={styles.description}>{item.description}</div>
                    <Button
                        type="secondary"
                        href={item.link}
                        className={styles.button}
                        onClick={onClick}
                    >
                        {item.cta}
                    </Button>
                </div>
            </div>
        </div>
    );
}

HpRespEditorialModuleItem.propTypes = {
    item: PropTypes.shape({
        imageUrl: PropTypes.string,
        link: PropTypes.string,
        cta: PropTypes.string,
        description: PropTypes.string,
    }).isRequired,
    onClick: PropTypes.func,
};

HpRespEditorialModuleItem.defaultProps = {
    onClick: () => {},
};

export { HpRespEditorialModuleItem };
